
/**
* @memberof rmOBA
* @ngdoc service
* @name rmUserPostalProductsData
* @param $q {service} promise service
* @param $http {service} angular http request promise service
* @description 
*   Get and put postal product data
*/

rmOBA.factory('rmUserPostalProductsData',
    function ($q, $http) {
        var USER_POSTAL_PRODUCT_DATA_ID = 'rm-oba-user-postal-product-data';


        return {

                /**
                * @memberof rmUserPostalProductsData
                * @function get
                * @desc Retreive saved  user-completed order lines
                * @returns {array} list of completed order lines as objects
                */ 
                get: function () {
                    return JSON.parse(localStorage.getItem(USER_POSTAL_PRODUCT_DATA_ID) || '[]');
                },

                /**
                * @memberof rmUserPostalProductsData
                * @function put
                * @desc Save user-completed order lines
                * @param {array} postalProduct Angular array of completed order lines
                */ 
                put: function (postalProduct) {
                    localStorage.setItem(USER_POSTAL_PRODUCT_DATA_ID, JSON.stringify(postalProduct));
                }
            };
        });